var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 1.65L18 0L16.25 1.65L14.5 0L12.75 1.65L11 0L9.25 1.65L7.5 0L5.75 1.65L4 0L2.25 1.65L0.5 0V22L2.25 20.35L4 22L5.75 20.35L7.5 22L9.25 20.35L11 22L12.75 20.35L14.5 22L16.25 20.35L18 22L19.75 20.35L21.5 22V0L19.75 1.65ZM19.1667 18.799H2.83333V3.201H19.1667V18.799ZM4 14.3H18V16.5H4V14.3ZM4 9.9H18V12.1H4V9.9ZM4 5.5H18V7.7H4V5.5Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatentsIcon);
export default __webpack_public_path__ + "static/media/patentsIcon.808f3648ea66f447a032ee80d47b310c.svg";
export { ForwardRef as ReactComponent };